import type { useAvailabilityPageController } from './useAvailabilityPageController';
import { GOVERNANCE_WEEKDAYS } from './availability-governance.utils';
import classes from './availability-page.module.scss';

type Props = Pick<ReturnType<typeof useAvailabilityPageController>, 'week' | 'canManageGovernance' | 'governanceDraft'
  | 'setGovernanceField' | 'governanceError' | 'governanceConflict' | 'isWeekBusy' | 'resetGovernanceDraft' | 'changeGovernance'>;

export function AvailabilityGovernanceControls({ week, canManageGovernance, governanceDraft, setGovernanceField,
  governanceError, governanceConflict, isWeekBusy, resetGovernanceDraft, changeGovernance }: Props) {
  if (!week?.governance) return null;
  const settings = { ...week.governance, ...governanceDraft };
  return <section aria-label="בקרת זמינות">
    {week.governance.deadlineWeekday !== null && <p>סגירת זמינות: {GOVERNANCE_WEEKDAYS[week.governance.deadlineWeekday]} {week.governance.deadlineTime}</p>}
    {week.access?.isManuallyLocked && <p role="status">הזמינות לשבוע זה נעולה</p>}
    {week.governance.historicalLockDate && <p role="status">נתונים נעולים עד {week.governance.historicalLockDate}</p>}
    {canManageGovernance && <fieldset className={classes.governanceControls} disabled={isWeekBusy}>
      <legend>הגדרות זמינות</legend>
      <label><input type="checkbox" checked={settings.deadlineWeekday !== null} onChange={event => {
        setGovernanceField('deadlineWeekday', event.currentTarget.checked ? 6 : null);
        setGovernanceField('deadlineTime', event.currentTarget.checked ? '21:00' : null);
      }} />מועד סגירה שבועי</label>
      {settings.deadlineWeekday !== null && <>
        <label>יום סגירת זמינות<select aria-label="יום סגירת זמינות" value={settings.deadlineWeekday}
          onChange={event => setGovernanceField('deadlineWeekday', Number(event.currentTarget.value))}>
          {GOVERNANCE_WEEKDAYS.map((day, index) => <option key={day} value={index}>{day}</option>)}
        </select></label>
        <label>שעת סגירת זמינות<input aria-label="שעת סגירת זמינות" type="time" step={60} value={settings.deadlineTime ?? ''}
          onContextMenu={event => event.preventDefault()} onChange={event => setGovernanceField('deadlineTime', event.currentTarget.value)} /></label>
      </>}
      <label>נעילת נתונים עד<input aria-label="נעילת נתונים עד" type="date" value={settings.historicalLockDate ?? ''}
        onContextMenu={event => event.preventDefault()} onChange={event => setGovernanceField('historicalLockDate', event.currentTarget.value || null)} /></label>
      {governanceConflict && <p role="alert">ההגדרות השתנו. אפסו את העריכה לפני שמירה.</p>}
      {governanceError && <p role="alert">{governanceError}</p>}
      <button type="button" className="button" disabled={governanceConflict} onClick={() => void changeGovernance('save')}>שמירת הגדרות</button>
      <button type="button" className="button" onClick={resetGovernanceDraft}>איפוס עריכה</button>
      <button type="button" className="button" onClick={() => void changeGovernance('weekLock')}>
        {week.access?.isManuallyLocked ? 'פתיחת זמינות לשבוע' : 'נעילת זמינות לשבוע'}
      </button>
      {week.governance.historicalLockDate && <button type="button" className="button" onClick={() => void changeGovernance('unlockHistory')}>פתיחת נתונים היסטוריים</button>}
    </fieldset>}
  </section>;
}